import { useState } from "react";

interface PublicCaptchaProps {
  onValidChange: (valid: boolean) => void;
  onReset: () => void;
}

const newPair = (): [number, number] => [
  Math.floor(Math.random() * 9) + 1,
  Math.floor(Math.random() * 9) + 1,
];

const PublicCaptcha = ({ onValidChange, onReset }: PublicCaptchaProps) => {
  const [pair, setPair] = useState<[number, number]>(newPair);
  const [answer, setAnswer] = useState("");

  const handleChange = (value: string) => {
    setAnswer(value);
    const parsed = parseInt(value, 10);
    onValidChange(value.trim() !== "" && parsed === pair[0] + pair[1]);
  };

  const handleReset = () => {
    setPair(newPair());
    setAnswer("");
    onValidChange(false);
    onReset();
  };

  return (
    <div className="psite-captcha">
      <span className="psite-captcha__prompt">
        Security check: {pair[0]} + {pair[1]} = ?
      </span>
      <input
        type="text"
        inputMode="numeric"
        placeholder="Answer"
        aria-label="Security check answer"
        value={answer}
        onChange={(e) => handleChange(e.target.value)}
        required
      />
      <button
        type="button"
        className="psite-captcha__reset"
        onClick={handleReset}
        title="Get a new code"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21 12a9 9 0 1 1-2.64-6.36" />
          <path d="M21 3v6h-6" />
        </svg>
        Reset
      </button>
    </div>
  );
};

export default PublicCaptcha;